import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppButton } from 'owa-command-ribbon';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type { IButtonStyles } from '@fluentui/react';
import { ActionControlId } from 'owa-ribbon-ids';
import loc from 'owa-localize';
import { switchBodyTypeText } from '../../utils/actionControlStrings.locstring.json';
import { EventHandler } from '../../utils/controlInfo';
import TextTRegular from 'owa-fluent-icons-svg/lib/icons/TextTRegular';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';

export const getSwitchBodyType = computedFn(
    (
        viewState: EditorViewState,
        switchBodyType: EventHandler,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        const label = loc(switchBodyTypeText);
        return createAppButton(
            getComposeRibbonId(ActionControlId.SwitchBodyType, viewState),
            label,
            switchBodyType,
            undefined /* keyTipProps */,
            TextTRegular,
            undefined /* iconColor */,
            styles,
            {
                customTooltip: getHoverTooltip(ActionControlId.SwitchBodyType, label),
            }
        );
    }
);
